import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaRegStar, FaHandshake, FaUserFriends, FaBullhorn, FaGraduationCap } from 'react-icons/fa';
import './Community.css';

const Community = () => {
  const mainColor = '#006186';
  const mainBg = { backgroundColor: '#006186' };

  return (
    <div className="community-page bg-white">
      {/* HEADER SECTION — В точности как на главной */}
      <section className="news-hero py-5">
        <Container>
            <h1 className="display-4 fw-bold mb-3" style={{ color: '#006186' }}>
              Как остаться на связи
            </h1>
            <div className="header-line mb-4" style={mainBg}></div>
            <p className="lead text-muted mb-0" style={{ maxWidth: '800px' }}>
              Ваше обучение не заканчивается получением диплома. Став частью нашей Ассоциации, 
              вы получаете доступ к огромной сети контактов и профессиональной поддержке.
            </p>
        </Container>
      </section>

      <Container className="py-5">
        {/* Блок 1: Участие в мероприятиях */}
        <Row className="mb-5 align-items-center">
          <Col lg={7} className="mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4 d-flex align-items-center" style={{ color: mainColor }}>
              <FaRegStar className="me-3" /> Участие в мероприятиях
            </h2>
            <p className="text-secondary fs-5">
              Мы регулярно проводим встречи, которые помогают выпускникам разных лет находить общие интересы.
            </p>
            <ul className="list-unstyled alumni-custom-list mt-4">
              <li><strong>Организация встреч:</strong> Помогите нам собрать вашу учебную группу на ежегодный День выпускника.</li>
              <li><strong>Региональные клубы:</strong> Создайте официальное представительство ОшТУ в вашем городе.</li>
              <li><strong>Фандрайзинг:</strong> Поддержите талантливых студентов через участие в благотворительных грантах.</li>
            </ul>
          </Col>
          <Col lg={5}>
            <Card className="border-0 shadow-sm p-4 bg-light-subtle rounded-4">
               <FaBullhorn size={40} className="mb-3 opacity-50" style={{ color: mainColor }} />
               <h5 className="fw-bold">Ближайшие события</h5>
               <p className="small text-muted">Следите за анонсами конференций и мастер-классов в нашем форуме.</p>
            </Card>
          </Col>
        </Row>

        <hr className="my-5 opacity-10" />

        {/* Блок 2: Менторство */}
        <Row className="mb-5 flex-lg-row-reverse align-items-center">
          <Col lg={7} className="mb-4 mb-lg-0 ps-lg-5">
            <h2 className="fw-bold mb-4 d-flex align-items-center" style={{ color: mainColor }}>
              <FaHandshake className="me-3" /> Программа наставничества
            </h2>
            <p className="text-secondary fs-5">
              Ваш профессиональный путь — это ценный урок для нынешних студентов.
            </p>
            <p className="text-muted">
              Программа менторства позволяет выпускникам делиться опытом, помогать студентам с выбором специализации и 
              давать советы по трудоустройству. Это отличный способ найти молодых талантов для своего бизнеса.
            </p>
            <Button
              className="fw-bold rounded-pill px-5 py-3 mt-3 border-0 shadow-sm text-uppercase"
              style={{ ...mainBg, letterSpacing: '1px', fontSize: '0.9rem' }}
              as={Link} 
              to="/donate"
            >
              Стать наставником
            </Button>
          </Col>
          <Col lg={5}>
             <div className="p-5 rounded-4 text-white shadow-lg d-flex flex-column align-items-center text-center" style={{ background: `linear-gradient(135deg, ${mainColor}, #004a66)` }}>
                <FaGraduationCap size={60} className="mb-3" />
                <h4 className="fw-bold">Помощь студентам</h4>
             </div>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default Community;